import IncomingLeadsContainer from './sold-container';

export default IncomingLeadsContainer;
